import { type Association } from "@entities";
import { associationRepo } from "@repositories";
import { type Dispatch, type FC, type SetStateAction, useEffect } from "react";
import RequesterDetails from "../../components/requester-details/RequesterDetails";
import { TwoCheckbox } from "../../components/two-checkbox/TwoCheckbox";
import { useRequest } from "../../contexts/RequestProvider";
import { OpportunityFormSection } from "./OpportunityFormSection";

interface OpportunityRequesterAssociationSectionProps {
  setIsAddAidRelated: Dispatch<SetStateAction<boolean>>;
}

export const OpportunityRequesterAssociationSection: FC<
  OpportunityRequesterAssociationSectionProps
> = ({ setIsAddAidRelated }) => {
  const { currentEvent: requestDetails, setCurrentEvent: setRequestDetails } =
    useRequest();
  const isAidRequest = requestDetails?.status === "AID_REQUEST";
  const hasAssociation = !!requestDetails?.associationRequested;
  const requesterUser = requestDetails?.associationRequested?.user;
  const associationRequestedId = requestDetails?.associationRequestedId;

  useEffect(() => {
    if (!associationRequestedId || requesterUser) return;

    let cancelled = false;
    void associationRepo
      .findId(associationRequestedId, { include: { user: true } })
      .then((association) => {
        if (cancelled || !association) return;
        setRequestDetails((prev) => ({
          ...prev,
          associationRequested: association,
          associationRequestedId: association.id,
        }));
      });

    return () => {
      cancelled = true;
    };
  }, [associationRequestedId, requesterUser, setRequestDetails]);

  return (
    <OpportunityFormSection title="שיוך למבקש סיוע">
      {!isAidRequest && (
        <TwoCheckbox
          labelClassName="more-details-label"
          isChecked={hasAssociation}
          handleChange={(event) => {
            const isYes = event.target.name === "yes";
            setRequestDetails((prev) => {
              if (!isYes) {
                return {
                  ...prev,
                  associationRequested: undefined,
                  associationRequestedId: null,
                };
              }
              if (prev.associationRequestedId || prev.associationRequested?.id) {
                return prev;
              }
              return {
                ...prev,
                associationRequested: {} as Association,
                associationRequestedId: null,
              };
            });
          }}
          text="שיוך למבקש הסיוע"
        />
      )}
      {(isAidRequest || hasAssociation) && (
        <RequesterDetails
          setIsAddAidRelated={setIsAddAidRelated}
          requesterDetails={requesterUser}
        />
      )}
    </OpportunityFormSection>
  );
};
